import { withAsyncBoundary } from '@toss/async-boundary';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { useSingularSubscriptionPaymentResult } from '../../../../services';
import { BusinessPaymentLayout } from '../../business/BusinessPaymentLayout';
import { BusinessPaymentInvalidPage } from '../../business/BusinessPayments';
import S from '../../business/BusinessPayments.module.scss';
import { paymentFailureFromQuery, readPaymentFailure } from '../../payment-tracking/paymentFailure';
import { PaymentFailureContent } from '../../payment-tracking/PaymentFailureContent';
const SingularPaymentsFailInner = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['business']);
  const paymentRequestHashId = (router.query.id ?? '').toString();
  const email = (router.query.email ?? '').toString();
  const {
    data: paymentInformation,
    isFetched
  } = useSingularSubscriptionPaymentResult({
    paymentRequestHashId,
    email
  });
  if (!isFetched) {
    return <></>;
  }
  return <BusinessPaymentLayout title={paymentInformation?.paymentRequest.customerName ?? ''} data-sentry-element="BusinessPaymentLayout" data-sentry-component="SingularPaymentsFailInner" data-sentry-source-file="SingularPaymentsFail.tsx">
      <div className={S.payments_result_section}>
        <h2 className={S.payments_result_title}>
          {t('business:business_payments_failure')}
        </h2>
        <PaymentFailureContent as="div" metadata={{
        pg_provider: 'unknown',
        // Toss 결제창 실패는 서버를 거치지 않아 PG 원문은 여기서만 받는다.
        ...readPaymentFailure({
          pg_error_code: router.query.code,
          pg_error_message: router.query.message
        }),
        ...paymentFailureFromQuery(router.query.paymentFailure),
        // 화면 흐름과 조회 응답의 spaceId 가 신뢰 값이다. 사용자가 고칠 수 있는 쿼리가 덮지 않게 마지막에 둔다.
        payment_flow: 'onetime_custom',
        space_id: paymentInformation?.spaceId ?? paymentFailureFromQuery(router.query.paymentFailure).space_id
      }} data-sentry-element="PaymentFailureContent" data-sentry-source-file="SingularPaymentsFail.tsx">
          <div>
            {t('business:business_payments_failure_content1', {
            name: paymentInformation?.paymentRequest.customerName
          })}
          </div>
          <div>{t('business:business_payments_failure_content2')}</div>
        </PaymentFailureContent>
      </div>
      <Button className={S.retry_button} size="lg" onClick={() => router.replace(`/payment/singular/${paymentRequestHashId}`)} data-sentry-element="Button" data-sentry-source-file="SingularPaymentsFail.tsx">
        {t('business:business_payments_retry_button')}
      </Button>
    </BusinessPaymentLayout>;
};
export const SingularPaymentsFail = withAsyncBoundary(SingularPaymentsFailInner, {
  pendingFallback: '',
  rejectedFallback: () => <BusinessPaymentInvalidPage />
});